import { FC, PropsWithChildren } from 'react';

import { GenericError } from '@components';
import { GenericErrorProps } from '@components/generic-error';

export interface WithErrorProps {
    error: boolean;
    className?: string;
    errorProps?: GenericErrorProps;
}

export const WithError: FC<Readonly<PropsWithChildren<WithErrorProps>>> = ({
    error,
    children,
    className,
    errorProps,
}) => {
    if (!error) {
        // eslint-disable-next-line
        return <>{children}</>;
    }

    return className ? (
        <div className={className}>
            <GenericError {...errorProps} />
        </div>
    ) : (
        <GenericError {...errorProps} />
    );
};
